
import React, {Component} from "react";

import Constants from "../../../../constants/constants";

import SideSection from "./side-section.js";

import "./progress-map.css";

class ProgressMap extends Component {
    render() {
        let {home_user, start_func, token} = this.props;

        console.log(home_user);

        //let mapURL = Constants.getPlayContentUrl() + "/progress-map?auth=" + encodeURIComponent(token);
        let mapURL = Constants.BACKEND_URL  + "/progress-map?auth=" + encodeURIComponent(token); 

        return (
            <div className='progress_view'>
                <iframe className='progress_map_frame' src={mapURL} title="Progress Map"  scrolling="no"/>
                {/* <script type="text/javascript" src="home_play_map.bundle.js"></script> */}
                {/* <div className='progress_view_map_text'>Hi {home_user.first_name}, Its great to see you again!<span className='home_progress_step_text'></span></div> */}
                {/* <ProgressGraph step={(home_user.home_progress + 1)} /> */}                
                <SideSection start_func={start_func} progress={(home_user.home_progress + 1)}></SideSection>
            </div>
        )

    }
}


export default ProgressMap;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/progress-map/progress-map.js